<template>
    <div v-if="doc" class="row">
        <div v-for="answer in answered" :key="answer.key"
            :class="answer.value.length > 60 ? 'col-sm-12' : 'col-sm-6'">
            <span class="text-sm mr-2">{{ answer.title }}</span>
            <p class="mr-2 mb-0">{{ answer.value }}</p>
        </div>
    </div>
</template>

<script>
import { answers } from "@/utils/surveyFields";

export default {
    name: "TilesResultsExtended",
    props: {
        doc: {
            type: Object,
            default: () => { },
        },
        // step 1 field definitions from the project content file
        fields: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        // every answer on the response, declared in the content file or not
        answered() {
            return answers(this.doc, this.fields);
        },
    },
};
</script>
